<section class="more px-8 mt-16">
  <p class="mt-8">
    Oprócz pojemników w naszej ofercie znajdziecie Państwo również inne akcesoria:
  </p>
  <ul class="mt-8 mb-8 list-disc pl-10">
    <li>łyżki</li>
    <li>szczypce</li>
    <li>pokrywki</li>
  </ul>
  <p class="mt-8">
    Na życzenie klienta dostarczamy też oprzyrządowanie; noże, stalki do ostrzenia, deski do krojenia, stojaki cenowe itp.
  </p>
</section>